// Email-format validation for the coupon "Specific customers" picker.
//
// The regex is copied verbatim from the legacy app util `~/utils/common.js`
// (`isValidEmailFormat`) — the same source `StoreSettings/utils/validation.ts`
// ported for the "Email notifications" input — so free-typed emails here are
// accepted / rejected identically to that field. Kept feature-local (rather
// than cross-importing another feature's internal util) following the house
// convention where features copy small helpers instead of coupling barrels.
const EMAIL_REGEX =
  /^[-a-z0-9~!$%^&*_=+}{\\'?]+(\.[-a-z0-9~!$%^&*_=+}{\\'?]+)*@([a-z0-9_][-a-z0-9_]*(\.[-a-z0-9_]+)*\.([a-z][a-z]+)|([0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}))(:[0-9]{1,5})?$/

export const isValidEmailFormat = (value: string): boolean =>
  EMAIL_REGEX.test(String(value).toLowerCase())
